import {EventEmitter, Injectable, Output} from '@angular/core';
import {loadModules} from 'esri-loader';
import esri = __esri;

@Injectable()

export class AGSLayer {
  @Output() public layerCheckBoxChecked = new EventEmitter();
  public url: string;
  public serviceLayerID: string;   // Unique id assigned to this layerElem by app.
  public name: string;  // Name displayed in TOC and other widgets identifying this layer
  public serviceLayerName: string;  // Layer name from service. Used to tie back to service layer.
  public serviceID: string; // Unique service name assigned to this service by app.
  public layerType: string;
  public fileType: string;
  public isLocalFile: boolean;
  public isGraphicsLayer: boolean;
  public objectIdField: string;
  public minScale: number;
  public maxScale: number;
  public visibleLayersArr: Array<any>;  // layer ids from service assigned to this layerElem
  public defaultThemeVisibleLayerArr: [number];
  public labelLayerIds = {};
  public defaultVisLabelLayerIds: [number];
  public download: string;
  public metadata: string;
  public videoLink: string;
  public transparency: number;
  public tags: [string];
  public relateObj: [{}];
  public layerDefinitionExp: string;
  public renderer: {
    symbol: {url?: string, contentType?: string, imageData?: string},
    uniqueValueInfos?: Array<any>, classBreakInfos?: Array<any>,
    field?: string, field1?: string, label?: string, minValue?: number, legendImageUrl?: string};
  public showDynamicLegend: boolean;
  public swatches: boolean;
  public rendererType: string;
  public customRenderer;
  public showLegend: boolean;
  public showInFullLegend: boolean;
  public dynamicLegend: Array<any>;
  public legendObj: any;
  public featLayImage: string;
  public isVisible: boolean;
  public isInScale: boolean;
  public description: string;
  public mapImageLayer: esri.MapImageLayer;
  public featureLayer: esri.FeatureLayer;
  public graphicsLayer: esri.GraphicsLayer;
  public imageryLayer: esri.ImageryLayer;
  public wmsLayer: esri.WMSLayer;
  public csvLayer: esri.CSVLayer;
  public map: any;
  public isChecked: boolean;
  public isParentChecked: boolean;
  public parentsChecked: boolean;
  public parentName: string;
  public layerOrder: number;
  public outFields: [string];
  public fields: [any];
  public formatFields: any;
  public disclaimer: any;
  public disclaimerDisplay: boolean;
  public dynamicLegendMinScale: number;
  public queryPickListFields: Array<any>;
  public rasterQuery: boolean;
  public displayField: string;
  public featureLayerUrl: string;
  public identifyType: any;
  public id: string;
  public type: string;
  public drawingInfo: any;
  public geometryType: string;
  public capabilities: string;
  public supportsAdvancedQueries: boolean;
  public supportedQueryFormats: string;
  public advancedQueryCapabilities: any;
  public dataSpatialReference: esri.SpatialReference;
  public serviceSpatialReference: esri.SpatialReference;
  public spatialReference: esri.SpatialReference;
  public relationships: [any];
  public label: boolean;
  public labelsVisible: boolean;
  public fullExtent: esri.Extent;
  public showLabels = false;
  public needsToken = false;
  public token: string;
  public layerAvailable = true;
  public layerImageUrl: string;
  public trans = true;
  public table = true;
  public nonSelectableArr = undefined;
  public serviceMetadataReturned = false;
  public timeSliderEnabled = false;
  public addLayerToMap = true;
  public layerDashboardName;
  public layerDashboardInfo;

  constructor(AGSLayerInfo: AGSLayer) {
    // Get passed in object properties and assign them to this element.
    const AGSLayerInfoKeys = Object.keys(AGSLayerInfo);
    if (AGSLayerInfoKeys) {
      for (const key of AGSLayerInfoKeys) {
        this[key] = AGSLayerInfo[key];
      }
    }
    this.isInScale = true;
    if (!this.isChecked) {
      this.isChecked = false;
    }
  }
  public loadLayer() {
  }

  public getType() {
    return this.layerType;
  }

  public getDescription() {
    return this.description;
  }

  public getVisibility() {
    return this.isVisible;
  }

  public setVisibility(visibleState: boolean) {
    this.isVisible = visibleState;
  }

  public toggleVisibility() {
    this.isVisible = ! this.isVisible;
  }

  public getScaleVisibility() {
    return this.isInScale;
  }

  public isLayerInScale(mapScale: number) {
    this.isInScale = (this.minScale === undefined || this.minScale === 0 || this.minScale >= mapScale)
      && (this.maxScale === undefined || this.maxScale === 0 || this.maxScale <= mapScale);
    return this.isInScale;
  }

  public isLayerAvailable() {
    return this.layerAvailable;
  }

  public setInScaleProp(isInScale: boolean) {
    this.isInScale = isInScale;
  }

  public setMinScale(scale: number) {
    this.minScale = scale;
  }

  public setMaxScale(scale: number) {
    this.maxScale = scale;
  }

  public getMinScale() {
    return this.minScale;
  }

  public getMaxScale() {
    return this.maxScale;
  }

  public setTransparency(transparency: number) {
    this.transparency = transparency;
  }

  public getVisibleLayersArr(visibleLayersArr: Array<any>): Array<any> {
    if (visibleLayersArr !== undefined && visibleLayersArr.length > 0) {
      if (Array.isArray(visibleLayersArr)) {
        return visibleLayersArr;
      } else {
        // this should probably get fixed at some point
        let layerArr: any;
        layerArr = visibleLayersArr;
        return layerArr.toString().split(',');
      }
    } else {
      return visibleLayersArr;
    }
  }

  public setDashboard(layerDashboardName: string) {
    this.layerDashboardName = layerDashboardName;
  }

  public async getMapLayer(this) {
    let layerObjType = this.layerType;
    if (!layerObjType) {
      layerObjType = 'map-image'; // default
    }
    switch (layerObjType.toLowerCase()) {
      case 'map-image':
        await this.getMapImageLayer(this);
        break;
      case 'feature':
        await this.getFeatureLayer(this);
        break;
      case 'image-service-layer':
      case 'esri.layers.ImageryLayer':
      case 'esri.layers.arcgisimageservicelayer':
        await this.getImageServiceLayer(this);
        break;
      case 'graphics':
        await this.getGraphicsLayer(this);
        break;
      case 'wms':
        await this.getWMSLayer(this);
        break;
      default:
        // Default is map-image
        await this.getMapImageLayer(this);
        break;
    }
  }

  public async getMapImageLayer(this) {
    // Create mapImageLayer object
    interface SubLayerPropertyType {
      id: number;
      visible: boolean;
      opacity?: number;
      minScale?: number;
      maxScale?: number;
      labelsVisible?: boolean;
      labelingInfo?: any;
      renderer?:any;
    }
    const [SubLayer, MapImageLayer] = await loadModules([
      'esri/layers/support/Sublayer',
      'esri/layers/MapImageLayer'
    ]);
    const sublayerColl = []; // switch to array of SubLayers ArcGIS JS 4.9
    const params: any = {};
    if (this.visibleLayersArr !== undefined && this.visibleLayersArr.length > 0) {
      // Add subLayers
      for (const layer of this.visibleLayersArr) {
        // Add subLayer properties from settings in config file if present
        const subLayerProperties: SubLayerPropertyType = {id: layer, visible: true};
        // min/max scale are now defined on the sublayer (js api 4.2)
        if (this.minScale) { subLayerProperties.minScale = this.minScale; }
        if (this.maxScale) { subLayerProperties.maxScale = this.maxScale; }
        if (this.transparency) { subLayerProperties.opacity = this.transparency; }
        if ((this.label !== undefined && this.label === false) ||
          (this.labelsVisible != undefined && this.labelsVisible === false)) {
           // If label is false Turn off label display for this layer or if labelsVisible = false
           //  give the label option in dropdown and allow user to turn on labels as needed
          subLayerProperties.labelsVisible = false;
        }
        if (this.customRenderer && this.customRenderer.renderer) {
          subLayerProperties.renderer = this.customRenderer.renderer;
        }
        
        sublayerColl.push(new SubLayer(subLayerProperties));  // *** ArcGIS JS 4.9
      }
      
      params.sublayers = sublayerColl;
    }
    params.url = this.url;
    params.id = this.serviceLayerID;
    /* if (this.token) {
      params.token = this.token;
    } */
    this.mapImageLayer = new MapImageLayer(params);
    // if transparency defined on layer, add it to the MapImageLayer
    this.transparency = this.mapImageLayer.opacity ? this.transparency : null;
    if (this.mapImageLayer && this.mapImageLayer.spatialReference) {
      this.dataSpatialReference = this.mapImageLayer.spatialReference;
    }
    return this.mapImageLayer;
  }

  public async getFeatureLayer(this) {
    const [FeatureLayer] = await loadModules([
      'esri/layers/FeatureLayer'
    ]);
    // Create feature layer object
    if (!this.featureLayer && this.url) {
      this.featureLayer = new FeatureLayer(
        {url: this.url, 
        id: this.serviceLayerID}
      );
      if (this.customRenderer && this.customRenderer.renderer) {
        this.featureLayer.renderer = this.customRenderer.renderer;
      }
    }
    if (this.featureLayer && this.featureLayer.spatialReference) {
      this.dataSpatialReference = this.featureLayer.spatialReference;
    }
  
    this.transparency = this.featureLayer.opacity ? this.transparency : null;
    this.featureLayer.labelsVisible = false;
    if (this.labelsVisible != undefined && this.labelsVisible != false) {
      this.featureLayer.labelsVisible = true;
    }
  
    return this.featureLayer;
  }

  public async getImageServiceLayer(this) {
    const [ImageryLayer] = await loadModules([
      'esri/layers/ImageryLayer'
    ]);
    // Create feature layer object
    if (!this.imageryLayer && this.url) {
      this.imageryLayer = new ImageryLayer({url: this.url, id: this.serviceLayerID});
    }
    if (this.format) {
      this.imageryLayer.format = this.format;  // The format of the exported image.
    }
    this.transparency = this.imageryLayer.opacity ? this.transparency : null;
    this.table = false;  // turn off table functionality for ImageServer services
    this.queryPickListFields = null;  // turn off query capability for ImageServer
    this.nonSelectableArr = '';  // ImageService services are not selectable
    return this.imageryLayer;
  }

  public getCSVLayer(this) {
    return this.csvLayer;
  }

  public getWMSLayer(this) {
    return this.wmsLayer;
  }

  public async getGraphicsLayer(this) {
    const [GraphicsLayer] = await loadModules([
      'esri/layers/GraphicsLayer'
    ]);
    // If graphicsLayer is passed as a property to the constructor, then just set the graphicsLayer property
    // on the AGSLayer element. If is has not been defined and there is a graphics property
    // passed to the constructor, than create a GraphicsLayer instance and add it to this element.
    if (! this.graphicsLayer && this.graphics) {
      this.graphicsLayer = new GraphicsLayer({graphics: this.graphics});
      // Set any other possible properties
      this.transparency = this.graphicsLayer.opacity ? this.transparency : null;
      this.id = this.graphicsLayer.id ? this.id : null;
      this.name = this.graphicsLayer.name ? this.name : null;
      this.minScale = this.graphicsLayer.minScale ? this.minScale : null;
      this.maxScale = this.graphicsLayer.maxScale ? this.maxScale : null;
      this.geometryType = 'graphics';
    }
    if (this.graphicsLayer) { this.isGraphicsLayer = true; }
    return this.graphicsLayer;
  }

  public setFileType(fileType: string) {
    this.fileType = fileType.toLowerCase();
    if (fileType === 'shapefile' || fileType === 'gpx' || fileType === 'csv') {
      this.isLocalFile = true;
    }
  }

  public getLegend() {
    return ;
  }

  public getUrl() {
    return this.url;
  }

  public getTags() {
    return this.tags;
  }

  public getDashboard() {
    return this.layerDashboardName;
  }

  public checkLayer(isChecked: boolean) {
    this.isChecked = isChecked;
  }

  public getOutFields() {
    return this.outFields;
  }

}
